var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionnaireInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.51,
    height: 14.519,
    viewBox: "0 0 14.51 14.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_1_",
    "data-name": "info (1)",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_1_2",
    "data-name": "info (1)",
    d: "M17.192,7.268a7.018,7.018,0,0,0-9.924,9.924,7.026,7.026,0,0,0,9.924,0,7.048,7.048,0,0,0,0-9.924Zm-.522,9.4a6.231,6.231,0,1,1,.037-8.842A6.283,6.283,0,0,1,16.67,16.67Zm-4.216-5.41a.473.473,0,0,1,.149.336v3.582a.364.364,0,0,1-.149.336.521.521,0,0,1-.336.112.6.6,0,0,1-.336-.112.473.473,0,0,1-.149-.336V11.6a.364.364,0,0,1,.149-.336.521.521,0,0,1,.336-.112.456.456,0,0,1,.336.112Zm.112-2.015a.479.479,0,0,1,.149.373.433.433,0,0,1-.149.373.639.639,0,0,1-.821,0,.479.479,0,0,1-.149-.373.433.433,0,0,1,.149-.373.639.639,0,0,1,.821,0Z",
    transform: "translate(-5.225 -5.225)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireInfo);
export default __webpack_public_path__ + "static/media/questionnaire-info.3dedaec080e6980acfb1ad4c5a1d3560.svg";
export { ForwardRef as ReactComponent };